import React, { ReactElement } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { EntityRowSpacing } from 'services/entities/types';
import { AppState } from 'services/types';
import { makeSelectRowSpacingsWithCorrectSetup } from 'services/equipmentSets/selectors';
import { EquipmentSetsProps } from 'services/equipmentSets/types';

type OwnProps = EquipmentSetsProps;

interface ConnectedProps {
    rowSpacingsWithCorrectSetup: EntityRowSpacing[];
}

export type Props = ConnectedProps & OwnProps;

export class RowSpacingsWithCorrectSetupAlertComponent extends React.PureComponent<
    Props
> {
    render(): ReactElement | null {
        const { rowSpacingsWithCorrectSetup } = this.props;

        if (
            !rowSpacingsWithCorrectSetup ||
            !rowSpacingsWithCorrectSetup.length
        ) {
            return null;
        }

        const subtitle = rowSpacingsWithCorrectSetup
            .map(calibration => `${calibration}m`)
            .join(', ');

        return (
            <Grid.Row>
                <Grid.Column>
                    <div className="calibration-status-section">
                        <h3 className="title">
                            Your equipment is setup for row widths:
                        </h3>
                        <p className="subtitle">{subtitle}</p>
                    </div>
                </Grid.Column>
            </Grid.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    rowSpacingsWithCorrectSetup: makeSelectRowSpacingsWithCorrectSetup()
});

export default connect(mapStateToProps)(
    RowSpacingsWithCorrectSetupAlertComponent
);
